/**
 * Shuttle Configuration
 * 
 * Defines preset pickup locations and times for shuttle services at events.
 * Keyed by community event ID. Falls back to a default config if no event-specific
 * config is found.
 */

export interface ShuttleStop {
  label: string;
  address: string;
  lat?: number;
  lng?: number;
}

export interface ShuttleTime {
  label: string;
  time: string; // HH:mm 24-hour format
}

export interface ShuttleEventConfig {
  stops: ShuttleStop[];
  times: ShuttleTime[];
}

// Keyed by community event UUID
const shuttleConfigs: Record<string, ShuttleEventConfig> = {
  // Breakaway Dallas
  "07ba29a6-c059-446d-a8b2-36a63e71a330": {
    stops: [
      { label: "Downtown Dallas - Reunion Tower", address: "300 Reunion Blvd E, Dallas, TX 75207", lat: 32.7757, lng: -96.8088 },
      { label: "Deep Ellum - Main St", address: "2600 Main St, Dallas, TX 75226", lat: 32.7836, lng: -96.7836 },
      { label: "Uptown Dallas - McKinney Ave", address: "2500 McKinney Ave, Dallas, TX 75201", lat: 32.7990, lng: -96.8010 },
      { label: "SMU Area - Mockingbird Station", address: "5465 E Mockingbird Ln, Dallas, TX 75206", lat: 32.8379, lng: -96.7730 },
    ],
    times: [
      { label: "2:00 PM", time: "14:00" },
      { label: "3:00 PM", time: "15:00" },
      { label: "4:00 PM", time: "16:00" },
      { label: "5:00 PM", time: "17:00" },
      { label: "6:00 PM", time: "18:00" },
    ],
  },
};

const defaultShuttleConfig: ShuttleEventConfig = {
  stops: [
    { label: "Downtown Pickup", address: "Downtown, TX" },
    { label: "Hotel District", address: "Hotel District, TX" },
  ],
  times: [
    { label: "3:00 PM", time: "15:00" },
    { label: "4:00 PM", time: "16:00" },
    { label: "5:00 PM", time: "17:00" },
  ],
};

export const getShuttleConfig = (eventId: string): ShuttleEventConfig => {
  return shuttleConfigs[eventId] || defaultShuttleConfig;
};
